module.exports = __webpack_public_path__ + "img/isologo.3b16b750.svg";